import React, { useState, Fragment } from "react";

import { useTranslation } from "react-i18next";

import { useNotification } from "@hooks/useNotification";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import { SvgDotsReorder } from "@routes/IconeSvg";
import { SvgBlackTrash, SvgChangeName } from "@routes/IconeSvg";
import { Draggable } from "react-beautiful-dnd";

//import {formatageDate} from "@helpers/_functions"
import TaskExpectedResult from "@components/onboarding/TaskExpectedResult";
import { Menu } from "@components/tailwindComponents";

import { OnboardingTask } from "@services/all.services";

import ModalDelete from "../components/ModalDelete";
import ModalTaskForm from "./modalTaskForm";

const BlackTooltip = withStyles(() => ({
  tooltip: {
    "maxWidth": "400px",
    "backgroundColor": "#3F3F51",
    "fontFamily": "Poppins_Medium",
    "fontSize": "13px",
    "padding": "4px 17px",
    "whiteSpace": "pre-line",
    "overflow": "hidden",
    "display": "-webkit-box",
    "-webkit-box-orient": "vertical",
    "-webkit-line-clamp": "6"
  }
}))(Tooltip);

// function formatageDate(date) {
//   if (!date || moment(date).isValid()) {
//     return "-";
//   }

//   return moment.format("DD/MM/YYYY");
// }

export default function ProtocolTaskItem({ task, index, taskList }) {
  const { showError, showSuccess } = useNotification();
  const [showModalDelete, setShowModal] = useState(false);
  const { t } = useTranslation("beginEnd.protocol");
  const [showUpdateTask, setShowUpdateTask] = useState(false);

  function toggleModalUpdateTask() {
    setShowUpdateTask((prevstate) => !prevstate);
  }

  async function deleteTask() {
    try {
      await OnboardingTask.deleteTask(task._id);
      showSuccess("delete_action_success", { object: "task" });
      setShowModal(false);
    } catch (err) {
      console.error(err);
      showError("error");
    }
  }
  function onDeleteClicked() {
    setShowModal(!showModalDelete);
  }

  return (
    <>
      <Draggable
        key={task._id}
        draggableId={task._id}
        index={index}
      >
        {(provider, snapshot) => {
          if (snapshot.isDragging) {
            // let style = {
            //   ...provider.draggableProps.style,
            //   top: "auto",
            //   left: "auto",
            //   display: "table",
            // };
            let style = {
              ...provider.draggableProps.style,
              display: snapshot.isDragging ? "table" : provider.draggableProps.style?.display
            };

            {/* let parent = document.querySelector(".draggable_content");

            if (parent) {
              const { top } = parent.getBoundingClientRect();
              style.top = style.top - top - 75;
            } */}
            provider.draggableProps.style = style;
          }

          return (
            <tr
              {...provider.draggableProps}
              ref={provider.innerRef}
              className="arh-border-x-0 arh-border-b arh-border-t-0 arh-border-solid arh-border-borderTable arh-text-left hover:arh-bg-greyColor"
            >
              <td className="arh-w-[20%] arh-px-18 arh-py-1.5 arh-text-fontBodyTable arh-font-medium arh-text-darkColor">
                <div className="arh-flex arh-items-center">
                  <BlackTooltip
                    placement="top"
                    title={task.name}
                    id={task._id}
                  >
                    <div
                      className={`GreenThemeSelect arh-w-full arh-max-w-fit arh-truncate arh-font-poppins arh-text-xs arh-font-medium arh-normal-case arh-text-darkGreyColor ${
                        snapshot.isDragging && "arh-w-40"
                      }`}
                      id={task._id}
                    >
                      {task.name}
                    </div>
                  </BlackTooltip>
                </div>
              </td>

              <td className="arh-w-[20%] arh-px-4 arh-py-1.5 arh-text-fontBodyTable arh-font-medium arh-text-darkColor">
                <TaskExpectedResult
                  type={task.expectedResultType}
                  t={t}
                />
              </td>

              <td className="arh-w-[50%] arh-px-4 arh-text-fontBodyTable arh-font-medium arh-text-darkColor">
                <BlackTooltip
                  placement="top"
                  title={task.detail}
                  id={task._id}
                >
                  <div
                    className="arh-w-full arh-max-w-fit arh-truncate arh-font-poppins arh-text-xs arh-font-medium arh-normal-case arh-text-darkGreyColor"
                    id={task._id}
                  >
                    {task.detail || "-"}
                  </div>
                </BlackTooltip>
              </td>

              <td
                {...provider.dragHandleProps}
                className="arh-w-[5%] arh-px-4 arh-text-fontBodyTable arh-font-medium arh-text-darkColor"
              >
                <div className="arh-flex arh-items-center arh-justify-end">
                  <SvgDotsReorder />
                </div>
              </td>
              <td className="arh-w-[5%] arh-px-4">
                <div className="arh-flex arh-items-center arh-justify-end">
                  <Menu
                    lists={[
                      {
                        icon: <SvgBlackTrash />,
                        title: "Effacer",
                        click: () => onDeleteClicked()
                      },
                      {
                        icon: <SvgChangeName />,
                        title: "Modifier",
                        click: () => toggleModalUpdateTask()
                      }
                    ]}
                    withIcon
                  />
                </div>
              </td>
            </tr>
          );
        }}
      </Draggable>

      <ModalTaskForm
        show={showUpdateTask}
        fragment={Fragment}
        onClickClose={toggleModalUpdateTask}
        protocolId={task.protocol}
        task={task}
        taskList={taskList}
      />
      <ModalDelete
        show={showModalDelete}
        onDelete={deleteTask}
        onCloseClicked={onDeleteClicked}
        object={t("cette tâche")}
      />
    </>
  );
}
